<template>
    <FlashMessage @close="close" :message="message" :error="error" />
</template>

<script>
import FlashMessage from '@/Components/Notifications/FlashNotifications/FlashMessage.vue'
export default {
    components: {
        FlashMessage,
    },

    data() {
        return {
            message: null,
            error: null,
        }
    },

    mounted() {
        this.$bus.on('flash-message', this.setMessage)
        this.$bus.on('flash-error', this.setError)
    },

    unmounted() {
        this.$bus.off('flash-message', this.clearConsentChoice)
        this.$bus.off('flash-error', this.clearConsentChoice)
    },

    methods: {
        close() {
            this.message = null
            this.error = null
        },

        setMessage(message) {
            this.message = message
        },

        setError(error) {
            this.error = error
        },
    },
}
</script>
